import { c as _c } from "react/compiler-runtime";
import { LotSelectionValue } from "@/components/inventory/lot-selection";
import { useShipmentPickerContext } from "@/components/inventory/shipment-picker";
import { useDoseLotPicker } from "./dose-lot-picker-context";

/** Adapt the clinical draft without taking ownership of receipts or quantities. */
export function useDoseLotSelection() {
  const $ = _c(25);
  const {
    state,
    actions,
    meta
  } = useDoseLotPicker();
  const picker = useShipmentPickerContext();
  const adapt = _temp;
  let t0;
  if ($[0] !== state.selected) {
    t0 = state.selected.map(adapt);
    $[0] = state.selected;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== state.available) {
    t1 = state.available.map(adapt);
    $[2] = state.available;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== state.search || $[5] !== state.showDepleted || $[6] !== t0 || $[7] !== t1) {
    t2 = {
      selected: t0,
      available: t1,
      search: state.search,
      showDepleted: state.showDepleted
    };
    $[4] = state.search;
    $[5] = state.showDepleted;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== actions.remove || $[10] !== actions.select || $[11] !== actions.setShowDepleted || $[12] !== picker.setSearchTerm) {
    t3 = {
      select: actions.select,
      remove: actions.remove,
      setSearch: picker.setSearchTerm,
      setShowDepleted: actions.setShowDepleted
    };
    $[9] = actions.remove;
    $[10] = actions.select;
    $[11] = actions.setShowDepleted;
    $[12] = picker.setSearchTerm;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== meta.canSelect) {
    t4 = meta.canSelect ? {
      accessibleLabelPrefix: "Select lot"
    } : undefined;
    $[14] = meta.canSelect;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== meta.listId || $[17] !== meta.locationNames || $[18] !== meta.medicationName || $[19] !== t4) {
    t5 = {
      listId: meta.listId,
      productName: meta.medicationName,
      locationNames: meta.locationNames,
      selection: t4
    };
    $[16] = meta.listId;
    $[17] = meta.locationNames;
    $[18] = meta.medicationName;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== t2 || $[22] !== t3 || $[23] !== t5) {
    t6 = {
      state: t2,
      actions: t3,
      meta: t5
    };
    $[21] = t2;
    $[22] = t3;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
}
function _temp(row) {
  return {
    id: row.id,
    label: row.label,
    details: row.shipment,
    disabled: row.disabled
  };
}